import { useTranslation } from 'react-i18next';
import { Box } from '@mui/material';

export default function OnboardingUsers(props: {
}) {
  const { t } = useTranslation('onboardingWizard.usersTab');

  return (
    <Box sx={{ p: 4 }}>
    </Box>
  );
}